import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from '@app/core/services/loader.service';
import { ILoaderState } from '@app/shared/models/ILoaderState';

@Component({
    selector: 'app-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.scss']
})
export class LoaderComponent implements OnInit {

    show = false;
    public options = {
      min: 8,
      max: 100,
      ease: 'linear',
      speed: 200,
      trickleSpeed: 300,
      meteor: true,
      spinner: false,
      direction: 'ltr+',
      color: 'black',
      thick: false
    };

    private subscription: Subscription;

    @ViewChild('progressBar') progressBar: any;

    constructor(private loaderService: LoaderService) { }

    ngOnInit() {

      this.subscription = this.loaderService.loaderState
        .subscribe((state: ILoaderState) => {
          this.show = state.show;
          if(state.show)
            this.progressBar.start();
          else
            this.progressBar.complete();
        });
    }

    onStarted() {

      this.show = true;
      // setTimeout(() => {
      //   this.startedClass = false;
      // }, 800);
    }

    onCompleted() {
      this.show = false;
      // setTimeout(() => {
      //   this.completedClass = false;
      // }, 800);
    }

    ngOnDestroy() {
      if(this.subscription)
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/loader/loader.component.ts